import {externalInstance} from '$utils/api'
import {createTanstackQuery} from '$utils/createQuery'

import type {
    CarInsuranceResponse,
    CarInsuranceStatement,
    FreeInsuranceDetailResponse,
    GuaranteeInsuranceResponse,
    GuaranteeInsuranceStatement,
    GeneralInsurance,
    InsuranceContractRequest,
    InsuranceContractResponse,
    InsuranceStatement,
    MyCarStatementsParams,
    MyDetailCarParams,
    MyDetailParams,
    MyStatementsParams,
    NoticeParams,
    NoticesResponse,
    RegionResponse,
    RCodeResponse,
    GetRegionByRCodeRequest,
    FreeInsuranceResponse,
    GetFreeInsuranceRequest,
    RegionListResponse,
    UniStatementResponse,
} from '$constants/api-infos'

export const getGeneralInsuranceDetailQuery = createTanstackQuery<GeneralInsurance, MyDetailParams>((params) => ({
    url: '/insurance/my/detail/general',
    method: 'GET',
    params,
}))

export const getGeneralInsuranceStatementsQuery = createTanstackQuery<
    UniStatementResponse<InsuranceStatement>,
    MyStatementsParams
>((params) => ({
    url: '/insurance/my/statements/general',
    method: 'GET',
    params,
}))

export const getNoticeQuery = createTanstackQuery<NoticesResponse, NoticeParams>((params) => ({
    url: '/insurance/my/notice',
    method: 'GET',
    params,
}))

export const getNoticesQuery = createTanstackQuery<NoticesResponse>(() => ({
    url: '/insurance/my/notices',
    method: 'GET',
}))

export const getMyCarInsuranceDetailQuery = createTanstackQuery<CarInsuranceResponse, MyDetailCarParams>((params) => ({
    url: '/insurance/my/detail/car',
    method: 'GET',
    params,
}))

export const getCarInsuranceStatementsQuery = createTanstackQuery<
    UniStatementResponse<CarInsuranceStatement>,
    MyCarStatementsParams
>((params) => ({
    url: '/insurance/my/statements/car',
    method: 'GET',
    params,
}))

export const getContractsQuery = createTanstackQuery<InsuranceContractResponse, InsuranceContractRequest>((params) => ({
    url: '/insurance/my/contracts',
    method: 'GET',
    params,
}))

export const getGuaranteeInsuranceDetailQuery = createTanstackQuery<GuaranteeInsuranceResponse, MyDetailParams>(
    (params) => ({
        url: '/insurance/my/detail/guarantee',
        method: 'GET',
        params,
    }),
)

export const getGuaranteeInsuranceStatementsQuery = createTanstackQuery<
    UniStatementResponse<GuaranteeInsuranceStatement>,
    MyStatementsParams
>((params) => ({
    url: '/insurance/my/statements/guarantee',
    method: 'GET',
    params,
}))

export const getFreeInsuranceDetailQuery = createTanstackQuery<FreeInsuranceDetailResponse, MyDetailParams>(
    (params) => ({
        url: '/insurance/free/detail',
        method: 'GET',
        params,
        fetcher: externalInstance,
    }),
)

export const getRegionsQuery = createTanstackQuery<RegionListResponse>(() => ({
    url: '/insurance/regions',
    method: 'GET',
    fetcher: externalInstance,
}))

export const getRCodeQuery = createTanstackQuery<RCodeResponse>(() => ({
    url: '/insurance/my/rCode',
    method: 'GET',
}))

export const getRegionByRCodeQuery = createTanstackQuery<RegionResponse, GetRegionByRCodeRequest>((params) => ({
    url: '/insurance/region',
    method: 'GET',
    params,
    fetcher: externalInstance,
}))

export const getFreeInsurancesByRCodeQuery = createTanstackQuery<FreeInsuranceResponse, GetFreeInsuranceRequest>(
    (params) => ({
        url: '/insurance/free/rcode',
        method: 'GET',
        params,
        fetcher: externalInstance,
    }),
)
